<template>
  <vbutton :label="label" @click="saveResponses" />
</template>

<script>
export default {
  name: "popup-send-button-default",
  props: {
    label: String,
    companyId: Number,
    responseLimitExpiredAction: String,
    sendingMethod: String
  },
  methods: {
    saveResponses() {
      this.$store
        .dispatch("company_new/update_rates", {
          company_id: this.companyId,
          save_no_paid_responses: this.responseLimitExpiredAction
        })
        .then(() => {
          if (this.sendingMethod === "sendInvites") {
            return this.$store.dispatch("invites/creation/sendInvites");
          }
          this.$store.commit("invites/creation/setForceSend", true);
          this.$store.dispatch("invites/creation/forceInvite");
        });
    }
  }
};
</script>
